import React from 'react';
import { Search } from 'components/gruenland/icons/Search';
import { useFormat } from 'helpers/hooks/useFormat';
import { Category } from 'types/entity/category';
import { Tile } from '../../../types';
import { CategoryGroup, CategoryList } from '../components/CategoryDisplay';
import { TilesSection } from '../components/TilesSection';
import { ViewAllLink } from '../components/ViewAllLink';

export interface Props {
  links: Category[];
  hideHeaderMenu: () => void;
  categoriesNavigator: Category[];
  insertCategory: (category: Category) => void;
  tileContent?: Tile[];
  onSearchClick?: () => void;
}

const MobileMenuContent: React.FC<Props> = ({
  links,
  categoriesNavigator,
  insertCategory,
  hideHeaderMenu,
  tileContent = [],
  onSearchClick,
}) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });
  const isAtRootLevel = categoriesNavigator.length === 0;
  const currentCategory = categoriesNavigator[categoriesNavigator.length - 1];
  const currentCategories = currentCategory?.descendants || [];

  const handleSearchClick = () => {
    onSearchClick?.();
    hideHeaderMenu();
  };

  return (
    <div className="overflow-auto px-5 pb-5">
      {!isAtRootLevel && currentCategory && <ViewAllLink category={currentCategory} onMenuClose={hideHeaderMenu} />}

      {isAtRootLevel ? (
        <>
          <CategoryList categories={links} onCategorySelect={insertCategory} onMenuClose={hideHeaderMenu} />

          <div className="my-6 border-t border-gray-200" />

          <button
            onClick={handleSearchClick}
            className="flex w-full items-center gap-4 py-3 text-left text-base font-medium text-gray-900 hover:text-green-600"
          >
            <Search className="size-5" />
            {formatMessage({ id: 'common.search', defaultMessage: 'Cerca' })}
          </button>
        </>
      ) : (
        <CategoryGroup categories={currentCategories} onCategorySelect={insertCategory} onMenuClose={hideHeaderMenu} />
      )}

      <TilesSection tiles={tileContent} />
    </div>
  );
};

export default MobileMenuContent;
